import type { FaireBrandEntity } from "../../entity_types/brand";

// King Floyd's — real Faire brand (b_2ytsec10es). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "King Floyd's"
// real-brand variant (advertiser 6775715154222277513).
export const b_2ytsec10es: FaireBrandEntity = {
  token: "b_2ytsec10es",
  type: "brand",
  name: "King Floyd’s",
  description: "Cocktail bitters, mixers, and flavored Virginia peanuts.",
  location: "Novato, CA, USA",
  isTopShop: true,
  tags: ["food-drink", "cocktail-bitters", "snacks"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
